import { render } from "./DownloadTheApp.vue?vue&type=template&id=4a122666&scoped=true"
import script from "./DownloadTheApp.vue?vue&type=script&lang=js"
export * from "./DownloadTheApp.vue?vue&type=script&lang=js"

import "./DownloadTheApp.vue?vue&type=style&index=0&id=4a122666&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a122666"]])

export default __exports__